import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	netoChatOne: 3,
	dialogTwo: 4,
	netoChatTwo: 5,
	clientChatOne: 6,
	netoChatThree: 7,
	showMonitorOne: 8,
	netoChatFour: 9,
	clientChatTwo: 10,
	dialogThree: 11,
	showMonitorTwo: 12,
	netoChatFive: 13,
	clientChatThree: 14,
	dialogFour: 15,
	winSubactivityTwo: 16,
}

export const Tema4SubtopicFourActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema4], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema4 activity 2");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 2: Simulación con un cliente." />
					<DialogBarNew
						dialog={
							"¡Excelente! mira ahí viene tu primer cliente. Estas a punto por efectuar tu primer cobro de productos. Recuerda saludarlo aplicando un Servicio Memorable."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.characterAnimations.idle)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Cobro de productos"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a02)
							setUiToShow(steps.netoChatOne);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.netoChatOne && (
				<>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Hola, buen día bienvenida."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a03)
							setUiToShow(steps.dialogTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Muy bien, Observa si tiene alguna necesidad."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a04)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							setUiToShow(steps.netoChatTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"¿Encontró todo lo que buscaba?"
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a05)
							setUiToShow(steps.clientChatOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolandaWithCoke} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Si, gracias."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a06)
							setUiToShow(steps.netoChatThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Comenzare a marcar."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.showMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityTwo.img1monitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.showMonitorOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.showMonitorOne && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Comenzare a marcar."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a07)
							setUiToShow(steps.netoChatFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoWithChips} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"En la compra de este refresco, por $13 pesos más, se puede llevar estas papitas."
						}
						callback={() => {
							setUiToShow(steps.clientChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a08)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolanda} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Si, estaría bien. Gracias."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a09)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							"Has aprendido bien. Realizaste una venta sugerida al cliente."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityTwo.img2monitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a10)
							setUiToShow(steps.showMonitorTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.showMonitorTwo && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Comenzare a marcar."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.hideMonitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a11)
							setUiToShow(steps.netoChatFive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatFive && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Su total seria de $30 pesos. ¿Pago con tarjeta o efectivo?"
						}
						callback={() => {
							setUiToShow(steps.clientChatThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act2_a12)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolandaWithMoney} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Efectivo"
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.winSubactivityTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winSubactivityTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="¡Excelente atención al cliente! Tu dedicación y profesionalismo son impresionantes."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							navigation("/home4/tema4/subtema4/activityThree");
						}}
					/>
				</>
			)}
		</>

	)
}